enum CompetitorsPriceRateAlertRuleRoomComparison {
    ANY = 'ANY', SAME = 'SAME'
}

export default CompetitorsPriceRateAlertRuleRoomComparison;